import InvoiceItemList from './InvoiceItemList';
import InvoiceItemShow from './InvoiceItemShow';
import InvoiceItemIcon from '@material-ui/icons/ListAlt';

export default {
    list: InvoiceItemList,
    show: InvoiceItemShow,
    icon: InvoiceItemIcon,
};
